import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '蚂蚁影视是否真的完全免费？',
    answer: '是的，蚂蚁影视提供完全免费的在线观影服务。我们通过广告收入来维持平台运营，用户无需支付任何费用即可观看所有内容。我们承诺不会对任何内容设置付费墙。',
  },
  {
    question: '观看需要注册账号吗？',
    answer: '不需要。蚂蚁影视支持免注册直接观看。如果你想享受收藏、历史记录、多设备同步等个性化功能，可以选择免费注册账号。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '蚂蚁影视支持在电脑浏览器、手机浏览器、平板电脑上直接观看。同时我们也提供了iOS和Android版本的APP，下载安装后即可在移动设备上获得更好的观影体验。',
  },
  {
    question: '为什么有时候视频加载较慢？',
    answer: '视频加载速度受多种因素影响，包括你的网络环境、设备性能以及同时在线观看的用户数量。蚂蚁影视采用了全球CDN加速技术来优化播放体验。如果遇到加载问题，建议检查网络连接或尝试切换清晰度。',
  },
  {
    question: '视频画质如何？支持哪些清晰度？',
    answer: '蚂蚁影视支持从流畅到4K超清多种画质选择。系统会根据你的网络状况自动选择最佳画质，你也可以在播放器中手动切换画质。对于热门影片，我们提供最高4K超清的选项。',
  },
  {
    question: '如何反馈问题或提出建议？',
    answer: '你可以通过关于我们页面的联系表单提交反馈，或者发送邮件到我们的客服邮箱。我们的团队会在24小时内回复你的问题。你也可以加入我们的官方社群与其他用户交流。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 bg-background-100" id="faq">
      <div className="site-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于蚂蚁影视的常见疑问解答</p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4 font-heading">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`ri-arrow-down-s-line text-sm ${
                    openIndex === index ? 'text-primary-600' : 'text-foreground-500'
                  }`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}